import { useQuery } from "@tanstack/react-query";
import { fetchProductStats } from "../services/productService";

export const useProductStats = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["productStats"],
    queryFn: () => fetchProductStats(),
    select: (response) => {
      return {
        stats: response.message || [],
      };
    },
  });

  return {
    stats: data?.stats || [],
    loading: isLoading,
    error: error?.message || null,
    pagination: data?.pagination || null,
  };
};
